import { render, staticRenderFns } from "./DataTemplateManager.vue?vue&type=template&id=0c70df1b&scoped=true&"
import script from "./DataTemplateManager.vue?vue&type=script&lang=js&"
export * from "./DataTemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./DataTemplateManager.vue?vue&type=style&index=0&id=0c70df1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70df1b",
  null
  
)

export default component.exports